var request = require('./request');

module.exports = function logEvent (type, version) {
  if (Math.random() >= 0.1) return;
  var host;
  var hosts = [
    'dianping.com',  
    'meituan.com', 
    'sankuai.com', 
    'meituan.net', 
    'maoyan.com',
    'm-zl-st.cfcmu.cn',
    'm-zl.mucfc.com'
  ];
  var hostsBeta = [
    'localhost',
    '51ping.com',
    'alpha.dp'
  ];
  for (var i = 0; i < hosts.length; i++) {
    if (location.href.indexOf(hosts[i]) !== -1) {
      host = 'm.dianping.com';
      break;
    }
  }
  if (!host) {
    for (var j = 0; j < hostsBeta.length; j++) {
      if (location.href.indexOf(hostsBeta[j])!==-1) {
        host = 'm.51ping.com';
      }
    }
  }
  if (host) {
    request({
        url: '//' + host + '/mtnb/api/statistics',
        data: {
            version: version,
            type: type
        }
    });    
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dp/knb/compiled/common/log.js
// module id = nUqn
// module chunks = 0